import styled from 'styled-components'
import { darkMode } from 'utilities/styled'

export const Fields = styled.div`
    form:last-child & > :last-child {
        margin-block-end: 0;
    }
`

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;

    &:not(.compact) {
        margin-block-end: 24px;
    }
`

export const Value = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
`

export const CompanyLogoWrapper = styled.div`
    .dark {
        display: none;
    }

    ${darkMode`
        .dark {
            display: block;
        }

        .light {
            display: none;
        }
    `}
`

export const CompanyLogo = styled.img`
    object-fit: contain;
    max-height: ${p => p.$size}px;

    &.dark {
        display: none;
    }

    ${darkMode`
        &.dark {
            display: block;
        }

        &.light {
            display: none;
        }
    `}
`